/* Keep original gallery behavior while supporting removable/reordered media blocks. */
(() => {
  'use strict';
  const mediaKey = source => (source || '').replace(/([?&])width=\d+/g, '').replace(/&amp;/g,'&');
  window.MXPrepareGallery = root => {
    const track = root.querySelector('[data-pv-track]');
    if (!track) return;
    let slides = [...track.querySelectorAll('[data-pv-slide]')];
    const wrap = root.querySelector('[data-pv-thumbs]');
    const originalThumbs = wrap ? [...wrap.querySelectorAll('[data-pv-thumb]')] : [];
    const originals = new Map(originalThumbs.map(t => [t.dataset.pvThumb, t]));
    const usable = slides.filter(slide => slide.querySelector('img,video') || window.Shopify?.designMode);
    slides.filter(slide => !usable.includes(slide)).forEach(slide => slide.remove());
    slides = usable;
    const thumbs = [];
    slides.forEach((slide, index) => {
      const key = slide.dataset.pvSlide;
      const img = slide.querySelector('img');
      const video = slide.querySelector('video');
      const previous = originals.get(key);
      if (wrap) {
        // Keep a deliberately hidden original thumbnail hidden. New media gets a new thumbnail.
        const newMedia = key.startsWith('new-');
        if (previous || newMedia) {
          const thumb = previous ? previous.cloneNode(true) : document.createElement('button');
          if (!previous) {thumb.type='button';thumb.className='pv-product__thumb';}
          thumb.dataset.pvThumb = String(index);
          thumb.classList.toggle('is-active', index === 0);
          thumb.classList.toggle('pv-product__thumb--video', Boolean(video));
          let preview = thumb.querySelector('img');
          const source = img?.getAttribute('src') || video?.getAttribute('poster');
          if (source && (!preview || mediaKey(source) !== mediaKey(preview.getAttribute('src')))) {
            if (!preview) {preview=document.createElement('img');preview.alt='';preview.loading='lazy';preview.width=60;preview.height=60;thumb.append(preview);}
            preview.src=source;preview.removeAttribute('srcset');
          }
          thumb.setAttribute('aria-label', (video ? 'Ver video ' : 'Ver imagen ') + (index + 1));
          thumbs.push(thumb);
        }
      }
      slide.dataset.pvSlide=String(index);
      slide.classList.toggle('is-active', index===0);
    });
    if (wrap) wrap.replaceChildren(...thumbs);
    root.querySelectorAll('[data-pv-prev],[data-pv-next]').forEach(button => {
      button.hidden=slides.length<2;
    });
  };
  // The original modal is outside the product's inner wrapper. Delegation also
  // survives section reloads and still works when its close button is removed.
  document.addEventListener('click', event => {
    const opener=event.target.closest('[data-pv-ingredients-open]');
    const closer=event.target.closest('[data-pv-modal-close]');
    if (opener) {
      const section=opener.closest('.shopify-section');
      const modal=section?.querySelector('[data-pv-ingredients-modal]') || document.querySelector('[data-pv-ingredients-modal]');
      if (modal) {event.preventDefault();modal.hidden=false;document.body.style.overflow='hidden';}
    }
    if (closer) {const modal=closer.closest('[data-pv-ingredients-modal]');if(modal){modal.hidden=true;document.body.style.overflow='';}}
  });
  document.addEventListener('keydown', event => {
    if(event.key==='Escape') document.querySelectorAll('[data-pv-ingredients-modal]').forEach(modal=>{if(!modal.hidden){modal.hidden=true;document.body.style.overflow='';}});
  });
})();
